export function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};
export const objectToArray = (object: Object) => Object.keys(object)
  .map(prop => object[ prop ]);

export const prop = property => obj => obj[ property ];

export const isPresent = (x: any): boolean => !!x;
